import { render } from "./DesiredModulesModal.vue?vue&type=template&id=50b055ac"
import script from "./DesiredModulesModal.vue?vue&type=script&lang=js"
export * from "./DesiredModulesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__